import { Component } from "react";

import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBRow,
  MDBCol,
} from "mdbreact";

import { withTranslation } from "react-i18next";

class AddMetadata extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oktaMetadataURL: this.props.oktaMetadataURL,
      office365MetadataURL: this.props.office365MetadataURL,
      toggleConfirm: false,
      deleteMetadataURL: "",
      toggleConfirmModify: false,
      modifyConfirmTitle: "No change detected.",
      modifyConfirmBody: "",
    };
  }

  confirmSubmitAddMetadataURLs = () => {
    if (
      this.state.oktaMetadataURL.trim() !== this.props.oktaMetadataURL ||
      this.state.office365MetadataURL.trim() !== this.props.office365MetadataURL
    ) {
      this.setState({
        modifyConfirmTitle: "Do you really want to update Metadata URL ?",
        modifyConfirmBody:
          "Note: Please migrate users to new application, otherwise they won't be able to access application.",
      });
    } else {
      this.setState({
        modifyConfirmTitle: "No change detected.",
        modifyConfirmBody: "",
      });
    }
    this.toggleModify();
  };

  submitAddMetadataURLs = () => {
    this.props.submitAddMetadataURLs(
      this.state.oktaMetadataURL,
      this.state.office365MetadataURL
    );
  };

  changeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  deleteMetadataURL = (idp) => {
    this.setState({
      deleteMetadataURL: idp,
    });
    this.toggle();
  };

  toggle = () => {
    this.setState({
      toggleConfirm: !this.state.toggleConfirm,
    });
  };

  confirmDelete = () => {
    // console.log("Delete", this.state.delete);
    if (this.state.deleteMetadataURL === "Okta") {
      this.props.submitAddMetadataURLs(" ", this.state.office365MetadataURL);
    } else if (this.state.deleteMetadataURL === "Office365") {
      this.props.submitAddMetadataURLs(this.state.oktaMetadataURL, " ");
    }
    this.toggle();
  };

  modifyMetadataURL = () => {
    this.toggleModify();
  };

  toggleModify = () => {
    this.setState({
      toggleConfirmModify: !this.state.toggleConfirmModify,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <MDBModal isOpen={this.state.toggleConfirm}>
          <MDBModalHeader toggle={this.toggle}>
            Confirm Delete {this.state.deleteMetadataURL}
          </MDBModalHeader>
          <MDBModalFooter>
            <MDBBtn color="danger" onClick={() => this.confirmDelete()}>
              Confirm
            </MDBBtn>
            <MDBBtn color="primary" onClick={this.toggle}>
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModal isOpen={this.state.toggleConfirmModify}>
          <MDBModalHeader toggle={this.toggleModify}>
            {this.state.modifyConfirmTitle}
          </MDBModalHeader>
          {this.state.modifyConfirmBody && (
            <MDBModalBody>{this.state.modifyConfirmBody}</MDBModalBody>
          )}
          <MDBModalFooter>
            {this.state.modifyConfirmTitle !== "No change detected." && (
              <MDBBtn
                color="danger"
                onClick={() => {
                  this.submitAddMetadataURLs();
                  this.toggleModify();
                }}
              >
                Confirm
              </MDBBtn>
            )}
            <MDBBtn color="primary" onClick={this.toggleModify}>
              Close
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>

        <MDBModalHeader toggle={this.props.toggleAddMetadataURLs}>
          <h4>
            {(!this.state.oktaMetadataURL || this.state.oktaMetadataURL.trim() === "") &&
            (!this.state.office365MetadataURL || this.state.office365MetadataURL.trim() === "")
              ? "Add Metadata"
              : "Modify Metadata"}
          </h4>
          <p>{t("addnewresident.required")}</p>
        </MDBModalHeader>

        <MDBModalBody>
          <form className="needs-validation" noValidate>
            <MDBRow>
              <MDBCol col="12">
                <label htmlFor="oktaMetadataURL" className="black-text">
                  Okta Metadata URL
                </label>
                <div class="d-flex justify-content-center">
                  <div class="input-group">
                    <input
                      id="oktaMetadataURL"
                      name="oktaMetadataURL"
                      className="form-control"
                      onChange={this.changeHandler}
                      value={this.state.oktaMetadataURL}
                    />
                    {this.props.oktaMetadataURL && (
                      <MDBBtn
                        onClick={() => this.deleteMetadataURL("Okta")}
                        color="danger"
                        right
                        size="sm"
                        type="button"
                      >
                        Delete
                      </MDBBtn>
                    )}
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol col="12">
                <label htmlFor="office365MetadataURL" className="black-text">
                  Office365 Metadata URL
                </label>
                <div class="d-flex justify-content-center">
                  <div class="input-group">
                    <input
                      id="office365MetadataURL"
                      name="office365MetadataURL"
                      className="form-control"
                      onChange={this.changeHandler}
                      value={this.state.office365MetadataURL}
                    />
                    {this.props.office365MetadataURL && (
                      <MDBBtn
                        onClick={() => this.deleteMetadataURL("Office365")}
                        color="danger"
                        right
                        size="sm"
                        type="button"
                      >
                        Delete
                      </MDBBtn>
                    )}
                  </div>
                </div>
              </MDBCol>
            </MDBRow>
            <div className="text-right submitButton">
              <MDBBtn
                color="danger"
                type="button"
                onClick={() => this.confirmSubmitAddMetadataURLs()}
              >
                {this.props.addMetadataURLs === true ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (this.props.oktaMetadataURL && this.props.oktaMetadataURL.trim() !== "") || 
                     (this.props.office365MetadataURL && this.props.office365MetadataURL.trim() !== "") ? (
                  "Modify Metadata"
                ) : (
                  "Add Metadata"
                )}
              </MDBBtn>
              <MDBBtn
                color="primary"
                onClick={this.props.toggleAddMetadataURLs}
              >
                Close
              </MDBBtn>
            </div>
          </form>
        </MDBModalBody>
      </>
    );
  }
}

export default withTranslation()(AddMetadata);
